import type { FC } from "react"

export const AdjustmentLotDeleteNotice: FC = () => <span className='text-secondary-600'>Lot will be deleted</span>
